import { Journey } from 'src/common/interfaces/journey.interface';
import { OrganizationUser } from 'src/common/interfaces/organization/user.interface';
import { Nullable } from 'src/types/nullable.type';
import { functionNoop } from 'src/utils/function/noop';
import { create } from 'zustand';

export const ChangeOwnershipPanelTypeMapping = {
  DASHBOARD: 1,
  SETTINGS: 2,
};

export type ChangeOwnershipPanelType =
  typeof ChangeOwnershipPanelTypeMapping[keyof typeof ChangeOwnershipPanelTypeMapping];

interface Variables {
  panelType: ChangeOwnershipPanelType;
  callback: () => void;
  userNameToBeRevoked: Nullable<string>;
  mapping: Map<Journey['uuid'], { journey: Journey; members: OrganizationUser[] }>;
}

interface Methods {
  setPanelType: (type: ChangeOwnershipPanelType) => void;
  onOwnerShipUpdated: (callback: () => void) => void;
  setUserNameToBeRevoked: (userName: string) => void;
  appendJourneyOwnerShip: (journey: Journey, members: OrganizationUser[]) => void;
  reset: () => void;
}

const initialState: Variables = {
  panelType: ChangeOwnershipPanelTypeMapping.DASHBOARD,
  mapping: new Map(),
  userNameToBeRevoked: null,
  callback: functionNoop,
};

type State = Variables & Methods;

export const useChangeOwnershipStore = create<State>((set, get) => ({
  ...initialState,
  setPanelType: (type) => {
    set({ panelType: type });
  },
  setUserNameToBeRevoked: (userName) => {
    set({ userNameToBeRevoked: userName });
  },
  appendJourneyOwnerShip: (journey, members) => {
    const { mapping } = get();
    mapping.set(journey.uuid, { journey, members });
  },
  onOwnerShipUpdated: (callback) => {
    set({ callback });
  },
  reset: () => {
    set({
      mapping: new Map(),
      panelType: ChangeOwnershipPanelTypeMapping.DASHBOARD,
    });
  },
}));
